export class TimeUtils {
    static now() {
        return Math.round(new Date().getTime() / 1000);
    }
}
